import { Component, Inject, OnInit } from '@angular/core';
import { GraphUser } from '../models/graph-user.model';
import { FormControl } from '@angular/forms';
import { DataService } from '../services/data.service';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-assignment-dialog',
  templateUrl: './assignment-dialog.component.html',
  styleUrls: ['./assignment-dialog.component.scss'],
  standalone: false,
})
export class AssignmentDialogComponent implements OnInit {
  onYes = new EventEmitter();

  primaryContact: GraphUser;
  primaryContactControl = new FormControl();
  primaryContactOptions: GraphUser[];
  lastFilter: string = '';

  formOwner: GraphUser;
  formOwnerControl = new FormControl();
  formOwnerOptions: GraphUser[];

  etsPacAssignment: GraphUser;
  etsPacAssignmentControl = new FormControl();
  etsPacAssignmentOptions: GraphUser[];

  currentAssignment: GraphUser;
  currentAssignmentControl = new FormControl();
  currentAssignmentOptions: GraphUser[];

  itSponsor: GraphUser;
  itSponsorControl = new FormControl();
  itSponsorOptions: GraphUser[];

  filteredPrimaryContactOptions: Observable<GraphUser[]>;

  constructor(
    private dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AssignmentDialogComponent>
  ) {}

  ngOnInit() {
    console.log('this.data :>> ', this.data);
    this.primaryContact = this.data.primaryContact;
    if (!this.primaryContact.mail) {
      this.primaryContact = null;
    }
    this.itSponsor = this.data.itSponsor;
    if (!this.itSponsor.mail) {
      this.itSponsor = null;
    }
    this.currentAssignment = this.data.currentAssignment;
    if (!this.currentAssignment.mail) {
      this.currentAssignment = null;
    }
    this.etsPacAssignment = this.data.etsPacAssignment;
    if (!this.etsPacAssignment.mail) {
      this.etsPacAssignment = null;
    }
    this.formOwner = this.data.formOwner;
    if (!this.formOwner.mail) {
      this.formOwner = null;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveAndClose() {
    let dataStructure = {
      primaryContact: this.primaryContact,
      itSponsor: this.itSponsor,
      currentAssignment: this.currentAssignment,
      etsPacAssignment: this.etsPacAssignment,
      formOwner: this.formOwner,
    };
    this.onYes.emit(dataStructure);
    this.dialogRef.close();
  }

  searchUsersPrimaryContact(searchText: any) {
    this.dataService.searchUsers(searchText).subscribe((result) => {
      this.primaryContactOptions = _.orderBy(result['value'], ['surname', 'givenName']);
      setTimeout(() => {
        document.getElementsByName('primaryContactField')[0].focus();
      });
    });
  }

  deletePrimaryContact() {
    this.primaryContact = '' as any;
    this.primaryContactOptions = [];
  }

  displayFnPrimaryContact(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    } else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    } else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    } else {
      return value;
    }
  }

  searchUsersFormOwner(searchText: any) {
    this.dataService.searchUsers(searchText).subscribe((result) => {
      this.formOwnerOptions = _.orderBy(result['value'], ['surname', 'givenName']);
      setTimeout(() => {
        document.getElementsByName('formOwnerField')[0].focus();
      });
    });
  }

  deleteFormOwner() {
    this.formOwner = '' as any;
    this.formOwnerOptions = [];
  }

  displayFnFormOwner(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    } else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    } else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    } else {
      return value;
    }
  }

  searchUsersEtsPacAssignment(searchText: any) {
    this.dataService.searchUsers(searchText).subscribe((result) => {
      this.etsPacAssignmentOptions = _.orderBy(result['value'], ['surname', 'givenName']);
      setTimeout(() => {
        document.getElementsByName('etsPacAssignmentField')[0].focus();
      });
    });
  }

  deleteEtsPacAssignment() {
    this.etsPacAssignment = '' as any;
    this.etsPacAssignmentOptions = [];
  }

  displayFnEtsPacAssignment(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    } else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    } else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    } else {
      return value;
    }
  }

  searchUsersCurrentAssignment(searchText: any) {
    this.dataService.searchUsers(searchText).subscribe((result) => {
      this.currentAssignmentOptions = _.orderBy(result['value'], ['surname', 'givenName']);
      setTimeout(() => {
        document.getElementsByName('currentAssignmentField')[0].focus();
      });
    });
  }

  deleteCurrentAssignment() {
    this.currentAssignment = '' as any;
    this.currentAssignmentOptions = [];
  }

  displayFnCurrentAssignment(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    } else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    } else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    } else {
      return value;
    }
  }

  searchUsersItSponsor(searchText: any) {
    this.dataService.searchUsers(searchText).subscribe((result) => {
      this.itSponsorOptions = _.orderBy(result['value'], ['surname', 'givenName']);
      setTimeout(() => {
        document.getElementsByName('itSponsorField')[0].focus();
      });
    });
  }

  deleteItSponsor() {
    this.itSponsor = '' as any;
    this.itSponsorOptions = [];
  }

  displayFnItSponsor(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    } else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    } else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    } else {
      return value;
    }
  }
}
